export default __webpack_public_path__ + "static/img_desktop_1-da3ab2932c14cfe0e26859e9758b60b8.jpg";